import { useQuery } from '@tanstack/react-query';
import * as qs from 'qs';

import { apiClient } from '@services/apiClient';

export const findSensorGatewayNodeRouterBySerialKey = (keys) => [
  'findSensorGatewayNodeRouterBySerial',
  keys?.locationIds,
  keys?.inputValue,
  keys?.equipmentType,
];

export const findSensorGatewayNodeRouterBySerialFn = ({ queryKey }) => {
  const params = {
    locationIds: queryKey[1],
    filters: {
      query: queryKey[2],
    },
  };

  const equipmentType = queryKey[3] === 'router' ? 'repeater' : queryKey[3] || 'sensor';

  return apiClient.get(`${APP_API_URL_V2}fsd/${equipmentType}s/search-by-serial`, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });
};

export const useFindSensorGatewayNodeRouterBySerialQuery = ({ locationIds, inputValue, equipmentType }) => {
  return useQuery({
    queryKey: findSensorGatewayNodeRouterBySerialKey({ locationIds, inputValue, equipmentType }),
    queryFn: findSensorGatewayNodeRouterBySerialFn,
    enabled: inputValue.length > 2,
    select: ({ data }) => data?.data || [],
  });
};
